import { observer } from 'mobx-react-lite';
import { NavLink } from 'react-router-dom';

import { IcSCopyIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton } from '@gem/ui-kit';

import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { SpaceAvatar } from 'APP/components/Avatar/SpaceAvatar/SpaceAvatar';
import { useCopyToClipboard } from 'APP/hooks/useCopyToClipboard/useCopyToClipboard';

import { MetaBlock } from '../MetaBlock/MetaBlock';
import { getSpaceLink, getSpaceAbsoluteLink } from './presenter';
import styles from './styles.m.css';

export const SpaceLink = observer(({ className, space }) => {
  const { t } = useTranslation();

  const copyToClipboard = useCopyToClipboard(
    getSpaceAbsoluteLink(space.id),
    t('common_link_copied')
  );

  const SpaceAvatarIcon = ({ className }) => (
    <SpaceAvatar
      className={className}
      space={space}
      type={AvatarTypes.Square_0}
      isShowLockIcon={false}
    />
  );

  return (
    <MetaBlock
      className={className}
      label={t('space_profile_inspace')}
      Icon={SpaceAvatarIcon}
      Actions={
        <>
          <IconButton
            Icon={IcSCopyIcon}
            onClick={copyToClipboard}
          />
        </>
      }
    >
      <NavLink
        className={styles.link}
        to={getSpaceLink(space.id)}
      >
        {space.name}
      </NavLink>
    </MetaBlock>
  );
});
